import { useCallback, useMemo } from "react";

import { Button } from "@/components/ui/button/button";

type Props = {
	children: React.ReactNode;
	appendItem: () => void;

	disabled?: {
		value: boolean;
		reason?: string;
	};
};

export const QuestionCardItemsWrapper = ({ children, appendItem, disabled }: Props) => {
	const handleClick = useCallback(() => {
		appendItem();
	}, [appendItem]);

	const variant = useMemo(() => (disabled?.value ? "disabled" : "outline"), [disabled?.value]);
	const tooltip = useMemo(() => (disabled?.value ? disabled?.reason : ""), [disabled?.value, disabled?.reason]);

	return (
		<div className="flex flex-col gap-y-6">
			{children}
			<span>
				<Button variant={variant} type={"button"} onClick={handleClick} tooltip={tooltip}>
					追加
				</Button>
			</span>
		</div>
	);
};
